export const appConfig = {
  APP_VERSION: '1.4.0'
};


